import { useCallback } from 'react';
import agent from '../../agent';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { freaksTranslate } from '../../utils/theFreaks';

/** The Freaks translator with the mobile app's keys: t('theFreaks.level', {level: 3}). */
export default function useFreaksT() {
  const { language } = useLanguageContext() ?? {};
  // game texts from the API (mission / gear names) follow the app language
  agent.TheFreaks.setLanguage(language);
  const t = useCallback((key, params) => freaksTranslate(language, key, params), [language]);
  return { t, language };
}
